import type { FC } from 'react';

import { useConfigSlice } from '../../store/slices/config/selectors';
import { useSettingsSlice } from '../../store/slices/settings/selectors';
import { formatNumber } from '../../utils/formatters';
import { L12nText } from '../text/L12nText';

import styles from './MaxPayoutText.module.css';

interface MaxPayoutTextProps {
  showAsterisk?: boolean;
  isHidden?: boolean;
  tk?: string;
  dynamicValues?: string[];
}

// TODO check if it comes from config/backend
const MAX_MULTIPLIER = 20_000;
const MAX_PAYOUT_VALUE_IN_EUR = 500_000;
const CURRENCY_SYMBOL = '€';
const DEFAULT_TK = 'MAXIMUM_PAYOUT_V3';

export const MaxPayoutText: FC<MaxPayoutTextProps> = ({
  isHidden = false,
  showAsterisk = false,
  tk = DEFAULT_TK,
  dynamicValues,
}) => {
  const locale = useSettingsSlice.currentLanguage();
  const isRTL = useSettingsSlice.getIsCurrentLanguageRTL();
  const config = useConfigSlice.tableConfig();

  const formattedMaxPayout = `${CURRENCY_SYMBOL}${formatNumber(locale, MAX_PAYOUT_VALUE_IN_EUR)}`;
  const formattedMultiplier = formatNumber(locale, MAX_MULTIPLIER);

  const _dynamicValues = tk === DEFAULT_TK ? [formattedMultiplier, formattedMaxPayout] : dynamicValues;

  if (!config?.payoutBetMaxLimit || isHidden) return null;
  return (
    <div className={styles.payout} dir={isRTL ? 'rtl' : undefined}>
      {showAsterisk ? '* ' : null}
      <L12nText tk={tk} dynamicValues={_dynamicValues} />
    </div>
  );
};
